import NBtn2 from './NBtn2'
export default NBtn2;